import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDevices2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconDevices2"><Path d="M21 9C22.1046 9 23 9.89543 23 11V19C23 20.1046 22.1046 21 21 21H17C15.8954 21 15 20.1046 15 19V11C15 9.89543 15.8954 9 17 9H21Z" fill="currentColor"/><Path d="M13.5 19C13.5 19.5368 13.6209 20.0454 13.8369 20.5H3C1.89543 20.5 1 19.6046 1 18.5V17C1 16.4477 1.44772 16 2 16H13.5V19Z" fill="currentColor"/><Path d="M19 3C20.1046 3 21 3.89543 21 5V7.5H17C15.067 7.5 13.5 9.067 13.5 11V14.5H3V5C3 3.89543 3.89543 3 5 3H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDevices2;
